import { ColumnConfig, PrincipalInvoiceColumnKey } from '../../model';

export const principalInvoiceConfig: Record<
  PrincipalInvoiceColumnKey,
  ColumnConfig
> = {
  invoiceNumberDate: {
    name: 'Invoice No. & Date',
    // isCheckboxField: false,
    isComponent: true,
  },
  // invoiceDate: {
  //   name: 'Invoice Date',
  //   sortField: 'invoiceDate',
  //   alignment: 'flex-end',
  // },
  // coNumber: {
  //   name: 'CO Number',
  // },
  // docType: {
  //   name: 'Doc Type',
  // },

  dueDate: {
    name: 'Due Date',
    sortField: 'dueDate',
    alignment: 'flex-end',
  },
  invoiceAmount: {
    name: 'Invoice Amount',
    sortField: 'invoiceAmount',
    alignment: 'flex-end',
  },
  customerName: {
    name: 'Customer Name',
    field: 'avatarNameStatus',
  },
  // amountPaid: {
  //   name: 'Amount Paid',
  //   sortField: 'paidAmount',
  //   alignment: 'flex-end',
  // },
  // paymentId: {
  //   name: 'Payment ID',
  //   isComponent: true,
  // },
  // orderNumber: {
  //   name: 'Order Number',
  //   isComponent: true,
  //   isAdditional: true,
  //   isVisible: false,
  // },

  reminders: {
    name: 'Message Status',
    isComponent: true,
  },
  engaged: {
    name: 'Engaged',
    isComponent: true,
  },
  status: {
    name: 'Status',
    isComponent: true,
  },
  action: {
    name: 'Actions',
    alignment: 'flex-end',
  },
};
